const routers = [
  {
    // 项目
    path: '/customer/list',
    name: 'customer',
    component: () => import('@/views/modules/crm/customer/List.vue')
  }
]
export default routers
